import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Checkbox, ListRow } from 'basic-components';
import { ReduxService } from 'dashboard-services';

import Pipi from 'primary/Pipi';

import classNames from 'classnames';
import './SuggestedRow.scss';

const emptyFun = () => {}
const SuggestedRow = ({ symbol, addToBasket, isSelected, isPatternSelected }) => {
  const [isOverflowed, setIsOverflowed] = useState(false),
        addToBasketLocal = useCallback(() => addToBasket(ReduxService.updateObject(symbol, { pattern: "false" })), [addToBasket, symbol]),
        taskPaneWidth = useSelector(state => state.globalState.taskPaneWidth),
        timeoutRef = useRef(),
        ref = useRef(),
        contentProps = useMemo(() => ({ ref }), [])

  useEffect(() => {
    if(ref.current) {
      setIsOverflowed(ref.current.scrollWidth > ref.current.clientWidth)
    } else {
      window.clearTimeout(timeoutRef.current)
      timeoutRef.current = window.setTimeout(() => setIsOverflowed(ref.current.scrollWidth > ref.current.clientWidth), 5)
    }
  }, [taskPaneWidth])

  useEffect(() => () => {
    window.clearTimeout(timeoutRef.current)
  }, [])

  return (
    <ListRow
        beforeChildren={(
          <Fragment>
            <Pipi isPatternSelected={isPatternSelected}/>
            <Checkbox
                checked={isSelected || isPatternSelected}
                disabled={isPatternSelected}
                onChange={emptyFun}
                onClick={addToBasketLocal}
            />
          </Fragment>
        )}
        className={classNames(
          "ng-office-app__authed__content__starting__block__content__suggested-row",
          { "ng-office-app__authed__content__starting__block__content__suggested-row--is-selected": isSelected },
          { "ng-office-app__authed__content__starting__block__content__suggested-row--is-overflowed": isOverflowed },
        )}
        contentProps={contentProps}
        height={44}
        offset={8000}
        onClick={addToBasketLocal}
        unmountIfInvisible={false}
    >
      <div className="ng-office-app__authed__content__starting__block__content__suggested-row__content">
        <div 
            className="ng-office-app__authed__content__starting__block__content__suggested-row__cell"
        >
          {symbol.symbols[symbol.mainSymbolKey]}
        </div>
        {(symbol.displayFields || []).map(field => (
          <div 
              className={classNames(
                "ng-office-app__authed__content__starting__block__content__suggested-row__cell",
                { "ng-office-app__authed__content__starting__block__content__suggested-row__cell--is-overflowed": isOverflowed }
              )}
              key={`${field.source} + ${field.key}`}
          >
            <div className="ng-office-app__authed__content__starting__block__content__suggested-row__cell__label">{field.key}:</div>
            <div className="ng-office-app__authed__content__starting__block__content__suggested-row__cell__value">{symbol[field.source][field.key]}</div>
          </div>
        ))}
      </div>
    </ListRow>
  )
}

SuggestedRow.defaultProps = {
  isPatternSelected: false,
  isSelected: false
}

SuggestedRow.propTypes = {
  addToBasket: PropTypes.func.isRequired,
  isPatternSelected: PropTypes.bool,
  isSelected: PropTypes.bool,
  symbol: PropTypes.object.isRequired
}

export default SuggestedRow;